/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Close_Track2_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close Track 2" |
*
* @param {Timeline_Legacy_Close_Track2_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_close_track2_aria_label = /** @type {((inputs?: Timeline_Legacy_Close_Track2_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Close_Track2_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gleis 2 schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi Traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть трек 2")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭轨道 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック2を閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक 2 बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Faixa 2")
	return /** @type {LocalizedString} */ ("Close Track 2")
});